import { cva, type VariantProps } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
    'inline-flex items-center shrink-1 justify-center rounded-sm text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-blue-500 disabled:pointer-events-none disabled:opacity-50 max-w-full',
    {
        variants: {
            variant: {
                default: 'bg-blue-600 text-white shadow-sm hover:bg-blue-700',
                destructive:
                    'bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90',
                outline:
                    'border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground',
                secondary: 'bg-white text-gray-600 border hover:bg-gray-100',
                combobox:
                    'font-normal border border-input bg-transparent shadow-xs hover:bg-accent/20 justify-start',
                ghost: 'hover:bg-accent hover:text-accent-foreground',
                'ghost-active': 'bg-accent text-accent-foreground',
                link: 'text-primary underline-offset-4 hover:underline',
                icon: 'rounded-full hover:bg-accent hover:text-accent-foreground',
                'icon-white':
                    'rounded-full hover:bg-white hover:text-accent-foreground hover:shadow-md',
                'combobox-block': 'w-full border border-input bg-transparent shadow-xs',
                'red-400': 'bg-red-400 text-white hover:bg-red-500',
                'orange-400': 'bg-orange-400 text-white hover:bg-orange-500',
                'amber-400': 'bg-amber-400 text-white hover:bg-amber-500',
                'yellow-400': 'bg-yellow-400 text-white hover:bg-yellow-500',
                'lime-400': 'bg-lime-400 text-white hover:bg-lime-500',
                'green-400': 'bg-green-400 text-white hover:bg-green-500',
                'emerald-400': 'bg-emerald-400 text-white hover:bg-emerald-500',
                'teal-400': 'bg-teal-400 text-white hover:bg-teal-500',
                'cyan-400': 'bg-cyan-400 text-white hover:bg-cyan-500',
                'sky-400': 'bg-sky-400 text-white hover:bg-sky-500',
                'blue-400': 'bg-blue-400 text-white hover:bg-blue-500',
                'indigo-400': 'bg-indigo-400 text-white hover:bg-indigo-500',
                'violet-400': 'bg-violet-400 text-white hover:bg-violet-500',
                'purple-400': 'bg-purple-400 text-white hover:bg-purple-500',
                'fuchsia-400': 'bg-fuchsia-400 text-white hover:bg-fuchsia-500',
                'pink-400': 'bg-pink-400 text-white hover:bg-pink-500',
                'rose-400': 'bg-rose-400 text-white hover:bg-rose-500',
                'slate-400': 'bg-slate-400 text-white hover:bg-slate-500',
                'gray-400': 'bg-gray-400 text-white hover:bg-gray-500',
                'zinc-400': 'bg-zinc-400 text-white hover:bg-zinc-500',
                'neutral-400': 'bg-neutral-400 text-white hover:bg-neutral-500',
                'stone-400': 'bg-stone-400 text-white hover:bg-stone-500',
            },
            size: {
                default: 'px-4 py-1',
                xs: 'h-6 text-xs px-3',
                xxs: 'h-4 text-xs px-2',
                sm: 'h-8 rounded-md px-3 text-xs',
                lg: 'h-10 rounded-md px-8',
                'icon-xxs': 'h-4 w-4',
                'icon-xs': 'h-5 w-5',
                'icon-sm': 'h-6 w-6',
                icon: 'h-9 w-9',
                combobox: 'px-3 py-[7px] rounded-md',
                'combobox-table-cell': 'text-xs w-full disabled:opacity-100',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
